export const games = {
    "yx": "GameFi",
    "yxms": "In the encrypted game, all decisions determining the results of the competition are generated in advance in the form of hashes, and the game results will not be altered by anyone's will, ensuring absolute fairness and justice!",
    "mnsm": "Simulated Trial",
    "ljqw": "Play Now",
    loading: 'Loading, please wait',
    dyh: 'Diversified option contracts for you to choose from, 100 times profit, super high short-term return on investment',
    qyhy:'Options Contracts',
    qsyhys:'Options',
    kd:'Open',
    qt:'Investment',
    ljjy: "Trade now",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/games/en.js